<template>
  <VueDatePicker
    v-bind="$attrs"
    class="e-date-picker"
    :dark="theme.global.current.value.dark"
    :enable-time-picker="false"
    model-type="yyyy-MM-dd"
    inline
    auto-apply
    :month-change-on-scroll="false">
    <template #arrow-left>
      <v-icon>icon-chevron-left</v-icon>
    </template>
    <template #arrow-right>
      <v-icon>icon-chevron-right</v-icon>
    </template>
    <template #calendar-icon>
      <v-icon>icon-calendar</v-icon>
    </template>
  </VueDatePicker>
</template>

<script setup>
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { useTheme } from 'vuetify'
import { VIcon } from 'vuetify/components/VIcon'

const theme = useTheme()
</script>

<style lang="scss">
@import '../../scss/styles';
.e-date-picker {
  --dp-font-family: 'inter';
  --dp-cell-border-radius: 50%;
  --dp-border-radius: 6px;
  --dp-font-size: 14px;
  --dp-month-year-row-height: 60px;
  .dp__month_year_wrap {
    @include callout-3;
  }

  .dp__calendar_header {
    @include body-3;
  }
  .dp__menu {
    overflow: hidden;
    box-shadow: 0px 6px 24px 0px #03346814;
    .dp__menu_inner {
      padding: 0;
      > div > div {
        padding: 8px;
      }
    }
  }

  .dp__month_year_row {
    background: $primary300;
    gap: 8px;
  }
  .dp__month_year_wrap {
    gap: 8px;
  }
  .dp__range_start.dp__range_end {
    border-radius: 50%;
  }
  .v-icon {
    color: white;
  }
  .dp--year-select,
  .dp__month_year_select {
    height: 36px;
  }
  .dp__inner_nav {
    &:hover {
      background: $primary400;
    }
  }
  .dp__month_year_select {
    color: white;
    &:hover {
      background: $primary400;
    }
  }
}
.dp__theme_light {
  &.dp__menu {
    border: none;
  }
  --dp-primary-color: #489ffe;
  --dp-border-color: transparent;
  --dp-menu-border-color: transparent;
  .dp__calendar_header {
    color: $grayscale400;
  }
}
.dp__theme_dark {
  --dp-background-color: #161718; //graybase;
  --dp-menu-border-color: #1a2027;
  --dp-primary-color: #489ffe;
  --dp-border-color: transparent;
  .dp__calendar_header {
    color: $grayscale300;
  }
}
</style>
